import { ISettingsState } from "./types";
import UserInterface from "@/types/app/IUser";

export default {
  setUser(state: ISettingsState, user: UserInterface) {
    state.error = false;
    state.user = user;
  },
  setUsers(state: ISettingsState, users: UserInterface[]) {
    state.error = false;
    state.users = users;
  },
  settingError(state: ISettingsState) {
    state.error = true;
  }
};
